import { PDFDocument } from 'pdf-lib';

export const handleMerge = async (permitName, urlsData) => {
  const mergedPdfBytes = await mergePDFs(urlsData);
  const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${permitName}-inspections.pdf`;

  return link;
};

export const mergePDFs = async pdfArray => {
  const mergedPdf = await PDFDocument.create();

  for (const pdfBytes of pdfArray) {
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const pages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());

    for (const page of pages) {
      mergedPdf.addPage(page);
    }
  }

  const mergedPdfBytes = await mergedPdf.save();
  return mergedPdfBytes;
};

export const uint8ArrayToBase64 = uint8Array => {
  let binary = '';
  const len = uint8Array.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(uint8Array[i]);
  }
  return btoa(binary);
};

// Runs `worker` over `items` with at most `limit` concurrent calls, preserving
// input order in the returned array. Used to download many inspection reports
// without firing hundreds of requests at once.
export async function runWithConcurrency<T, R>(
  items: T[],
  limit: number,
  worker: (item: T, index: number) => Promise<R>,
): Promise<R[]> {
  const results: R[] = new Array(items.length);
  let next = 0;
  const run = async (): Promise<void> => {
    while (next < items.length) {
      const i = next;
      next += 1;
      results[i] = await worker(items[i], i);
    }
  };
  await Promise.all(Array.from({ length: Math.min(limit, items.length) || 0 }, run));
  return results;
}
